// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import { prepareNestedString } from 'helpers/reduxFormFunctions'

// gets nested value of an object.
// obj is the object and
// pathString is the string that points to the desired value.
// example:
// obj = {
//   foo: [{
//     bar: {
//       fa: 'Test',
//     },
//   }],
// }
// pathString = foo[0]bar.fa
// getNestedByString (obj, pathString) => 'Test'

/**
 * returns the specified nested value within an object
 * @param {Object} obj - literally any ol'POJO
 * @param {String} pathString - a string which points to the nested value. eg: foo[0]bar.fa
 * @returns {*} - returns whatever value was specified.
 */
const getNestedByString = (obj, pathString) => {
  // o tracks the 'current level' as we loop into the object.
  let o = obj

  // p is the property for the next level we want to access
  for (const p of prepareNestedString(pathString)) {
    // if the current level we're at is null or undefined,
    // then we can't go deeper. Just return that current value
    if (o === null || o === undefined) {
      break
    }

    // now we'll assign the 'next level'
    o = (
      // if the current level we're has has a property
      // for the next level in, then assign that value as the next level.
      o.hasOwnProperty(p)
        ? o[p]
        // if we're here that means that the current level doesn't have a
        // property to match the next level. Since we can't go any deeper,
        // just return null.
        : null
    )
  }

  return o
}

export default getNestedByString
